/**
 * Support cases (v4.62) — ticketed threads user ↔ gouverneur (+ escalate to admin).
 */

import api from './api.js';

export async function openCase(payload) {
  const response = await api.post('/support/cases', payload);
  return response.data;
}

export async function getMyCases(filters = {}) {
  const params = new URLSearchParams();
  if (filters.limit) params.append('limit', filters.limit);
  if (filters.offset) params.append('offset', filters.offset);
  const response = await api.get(`/support/cases/mine?${params}`);
  return response.data;
}

export async function getCaseQueue(filters = {}) {
  const params = new URLSearchParams();
  if (filters.limit) params.append('limit', filters.limit);
  const response = await api.get(`/support/cases/queue?${params}`);
  return response.data;
}

export async function getAssignedCases(filters = {}) {
  const params = new URLSearchParams();
  if (filters.limit) params.append('limit', filters.limit);
  const response = await api.get(`/support/cases/assigned?${params}`);
  return response.data;
}

export async function listAllCases(filters = {}) {
  const params = new URLSearchParams();
  if (filters.statut) params.append('statut', filters.statut);
  if (filters.type) params.append('type', filters.type);
  if (filters.q) params.append('q', filters.q);
  if (filters.limit) params.append('limit', filters.limit);
  const response = await api.get(`/support/cases?${params}`);
  return response.data;
}

export async function getCase(caseId) {
  const response = await api.get(`/support/cases/${caseId}`);
  return response.data;
}

export async function acceptCase(caseId) {
  const response = await api.post(`/support/cases/${caseId}/accept`);
  return response.data;
}

export async function postCaseMessage(caseId, body) {
  const response = await api.post(`/support/cases/${caseId}/messages`, body);
  return response.data;
}

export async function escalateCase(caseId) {
  const response = await api.post(`/support/cases/${caseId}/escalate`);
  return response.data;
}

export async function requestCloseCase(caseId) {
  const response = await api.post(`/support/cases/${caseId}/request-close`);
  return response.data;
}

export async function closeCase(caseId, reason) {
  const response = await api.post(`/support/cases/${caseId}/close`, { reason });
  return response.data;
}

export async function addCaseCc(caseId, userIds) {
  const response = await api.post(`/support/cases/${caseId}/participants`, { userIds });
  return response.data;
}

export async function getCcCandidates() {
  const response = await api.get('/support/cases/cc-candidates');
  return response.data;
}

export async function getSupportBadges() {
  const response = await api.get('/support/stats/badges');
  return response.data;
}

export async function getSupportSettings() {
  const response = await api.get('/support/settings');
  return response.data;
}

export async function updateSupportSettings(updates) {
  const response = await api.patch('/support/settings', updates);
  return response.data;
}

/** Authenticated blob URL for a case attachment */
export async function getCaseAttachmentObjectUrl(caseId, attachmentId) {
  const response = await api.get(`/support/cases/${caseId}/attachments/${attachmentId}`, {
    responseType: 'blob',
  });
  return URL.createObjectURL(response.data);
}

export async function getAppMeta() {
  const response = await api.get('/meta/app');
  return response.data;
}
